import { render, staticRenderFns } from "./MobilePlans.vue?vue&type=template&id=e1349064&"
import script from "./MobilePlans.vue?vue&type=script&lang=js&"
export * from "./MobilePlans.vue?vue&type=script&lang=js&"
import style0 from "./MobilePlans.vue?vue&type=style&index=0&id=e1349064&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports